const readMore = document.querySelectorAll('.read-more__show');
const readLess = document.querySelectorAll('.read-more__hide');

const addToggling = el => {
    [].forEach.call(el,elButton => {
        elButton.addEventListener('click', (e) => {
            const readMoreContent = elButton.parentElement;
            e.preventDefault();
            readMoreContent.classList.toggle('active');
        })
    })
};

if (readMore.length) {
    addToggling(readMore);
}

if (readLess.length) {
    addToggling(readLess);
}